/**
 * If the planner has selected an existing event for this quote request
 * then they must also be choosing a member from their contact list. We
 * want to switch our "next" button to be a submit button and enable or
 * disable it depending on whether one or more members have been
 * selected or not.
 *
 * There's no possibility to proceed to another step in this situation:
 * they must choose who they'd like to request quotes from for their
 * existing event or go back and request a new service instead.
 */
function updateContactListSubmitButton() {
	const nextStepButton = this.currentStepElement.querySelector('.js-quote-step-next');
	let nextStepButtonLabel = nextStepButton.querySelector('.ladda-label');

	if (!nextStepButtonLabel) {
		nextStepButtonLabel = nextStepButton;
	}

	const quoteRequest = this.collect();
	const existingEventRoleID = quoteRequest.get('event_role');

	if (existingEventRoleID && existingEventRoleID !== 'new') {
		nextStepButton.dataset.submit = 'true';
		nextStepButtonLabel.textContent = 'Submit';

		// Let's also update the percentage completion for nicer
		// feedback in the UI. If we don't have the original value
		// stored for backup, save it via separate data attribute.
		if (!this.currentStepElement.dataset.percentageCompleteSaved) {
			this.currentStepElement.dataset.percentageCompleteSaved = this.currentStepElement.dataset.percentageComplete;
		}

		// Arbitrarily set progress to 90%.
		this.currentStepElement.dataset.percentageComplete = 90;

		const checkedContactListVendors = quoteRequest.getAll('contact_list_vendors[]');
		if (checkedContactListVendors.length) {
			console.log('Existing event selected and contact list vendors selected. Active submit mode!');
			nextStepButton.disabled = false;
		} else {
			console.log('Existing event selected and no contact list vendors selected. Disabled submit mode!')
			nextStepButton.disabled = true;
		}

		return;
	}

	console.log('No existing event selected. Next step mode!');
	delete nextStepButton.dataset.submit;
	nextStepButton.disabled = false;
	nextStepButtonLabel.textContent = 'Next';

	// If we saved the percentage complete previously we want to
	// restore to what it was originally.
	if (this.currentStepElement.dataset.percentageCompleteSaved) {
		this.currentStepElement.dataset.percentageComplete = this.currentStepElement.dataset.percentageCompleteSaved;
	}
}

export {
	updateContactListSubmitButton
}